export class FuelRecordDefault {
    id!: string
    equipment!: string
    description!: string
    costCode!: number
    costType!: number
    offsetGl!: number
}
